const OBJECT_ID_PATTERN = /^[a-f\d]{24}$/i;

export function isObjectId(value: string): boolean {
  return OBJECT_ID_PATTERN.test(value);
}

export function objectIdPath(value: string, label: string): string {
  if (!isObjectId(value)) {
    throw new Error(`Invalid ${label} ID`);
  }
  return value;
}
